import { userConstants } from '../_constants';

export function forgotPin(state = {}, action) {
  switch (action.type) {
    case userConstants.FORGOTPIN_REQUEST:
      return {
        ...state,
        forgotpin: true,
        requestedData: action.mpin.Data,
      };
    case userConstants.FORGOTPIN_SUCCESS:
      return {
        ...state,
        forgotpin: true,
        data: action.mpin.data,
      };
    case userConstants.FORGOTPIN_FAILURE:
      return {
        ...state,
        forgotpin: false,
        data: action.mpin.data,
      };
    case userConstants.RESET_MSG:
      return {
        ...state,
        forgotpin: false,
        data: action.payload,
      };
    default:
      return state;
  }
}
